module.exports = __webpack_public_path__ + "img/ftm.53d03f62.svg";